import { render } from "./divedit.vue?vue&type=template&id=6978b444&scoped=true&ts=true"
import script from "./divedit.vue?vue&type=script&lang=ts"
export * from "./divedit.vue?vue&type=script&lang=ts"

import "./divedit.vue?vue&type=style&index=0&id=6978b444&lang=less&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6978b444"]])

export default __exports__